<template>
    <b-container fluid class="fluxo-caixa-container"> 
        <ModalExportar />
        <el-tabs type="border-card">
            <el-tab-pane>
                <span slot="label"><i class="far fa-chart-bar"></i> Fluxo de Caixa</span>
                <b-row>
                    <div class="col-lg-12 col-md-12 mt-2">
                        <container-card id="filtroFluxoDeCaixa" icon="fa-filter" title="Selecione as opções de pesquisa.">
                            <b-card footer-tag="footer"><!-- FILTROS -->
                                
                                <b-form @submit="pesquisarFluxo" id="formFiltro2">
                                    <b-form-row>
                                        <div class="col-md-12">
                                            <SelectMarcas v-model="model.marcas" />
                                            <div class="filtro-content-box">
                                                <b-form-row class="mb-2">
                                                    <div class="col-lg-12 col-md-12">
                                                        <b-form-row class="mb-2">
                                                            <div class="col-lg-2 col-md-2">
                                                                <b-form-group id="data_inicio_fim" label="Período">
                                                                    <el-select class="w-100 d-block" size="small" v-model="model.Periodo" @change="changePeriodo">
                                                                        <el-option label="Diario" value="Diario"></el-option>
                                                                        <el-option label="Mensal" value="Mensal"></el-option>
                                                                        <el-option label="Semestral" value="Semestral"></el-option>
                                                                        <el-option label="Trimestral" value="Trimestral"></el-option>
                                                                    </el-select>
                                                                </b-form-group>
                                                            </div>
                                                            <div class="col-lg-4 col-md-4">
                                                                <b-form-group id="data_inicio_fim" label="Data início/Fim:">
                                                                    <div class="toogle-multiselect-cluster">
                                                                        <small>{{ model.Periodo }}&nbsp;&nbsp;</small>
                                                                    </div>
                                                                    <div v-show="model.Periodo === 'Diario'">
                                                                        <el-date-picker
                                                                            v-model="model.month"
                                                                            type="daterange"
                                                                            :picker-options="pickerOptions"
                                                                            range-separator="|"
                                                                            start-placeholder="De"
                                                                            end-placeholder="Até"
                                                                            align="right"
                                                                            format="dd/MM/yyyy"
                                                                            size="small"
                                                                            class="w-100">
                                                                        </el-date-picker>
                                                                    </div>
                                                                    <div v-show="model.Periodo === 'Semestral'">

                                                                        <el-row :gutter="10">
                                                                            <el-col
                                                                                :xs="24"
                                                                                :sm="12"
                                                                                :md="14"
                                                                                :lg="16"
                                                                                :xl="18"
                                                                            >
                                                                                <el-select class="w-100 d-block" size="small" v-model="model.month" style="width: 53%;">
                                                                                    <el-option :label="`1° Sem - 01/01/${anoAtualFormatado} a 30/06/${anoAtualFormatado}`" :value="[`${anoAtualFormatado}-01-01`, `${anoAtualFormatado}-06-30`]"></el-option>
                                                                                    <el-option :label="`2° Sem - 01/07/${anoAtualFormatado} a 31/12/${anoAtualFormatado}`" :value="[`${anoAtualFormatado}-07-01`, `${anoAtualFormatado}-12-31`]"></el-option>
                                                                                </el-select>
                                                                            </el-col>
                                                                             <el-col
                                                                                :xs="24"
                                                                                :sm="12"
                                                                                :md="10"
                                                                                :lg="8"
                                                                                :xl="6"
                                                                            >
                                                                                <el-date-picker
                                                                                    v-model="anoAtual"
                                                                                    type="year"
                                                                                    align="right"
                                                                                    size="small"
                                                                                    class="w-100 d-block">
                                                                                </el-date-picker>
                                                                            </el-col>
                                                                        </el-row>
                                                                    </div>
                                                                    <div v-show="model.Periodo === 'Mensal'">
                                                                        <el-date-picker
                                                                            v-model="model.month"
                                                                            type="monthrange"
                                                                            range-separator="|"
                                                                            start-placeholder="De"
                                                                            end-placeholder="Até"
                                                                            align="right"
                                                                            format="MM/yyyy"
                                                                            size="small"
                                                                            class="w-100">
                                                                        </el-date-picker>
                                                                    </div>
                                                                    
                                                                    <div v-show="model.Periodo === 'Trimestral'">
                                                                        <el-row :gutter="10">
                                                                            <el-col
                                                                                :xs="24"
                                                                                :sm="12"
                                                                                :md="14"
                                                                                :lg="16"
                                                                                :xl="18"
                                                                            >
                                                                                <el-select class="w-100 d-block" size="small" v-model="model.month">
                                                                                    <el-option :label="`1° Tri - 01/01/${anoAtualFormatado} a 31/03/${anoAtualFormatado}`" :value="[`${anoAtualFormatado}-01-01`, `${anoAtualFormatado}-03-31`]"></el-option>
                                                                                    <el-option :label="`2° Tri - 01/04/${anoAtualFormatado} a 30/06/${anoAtualFormatado}`" :value="[`${anoAtualFormatado}-04-01`, `${anoAtualFormatado}-06-30`]"></el-option>
                                                                                    <el-option :label="`3° Tri - 01/07/${anoAtualFormatado} a 30/09/${anoAtualFormatado}`" :value="[`${anoAtualFormatado}-07-01`, `${anoAtualFormatado}-09-30`]"></el-option>
                                                                                    <el-option :label="`4° Tri - 01/10/${anoAtualFormatado} a 31/12/${anoAtualFormatado}`" :value="[`${anoAtualFormatado}-12-31`, `${anoAtualFormatado}-12-31`]"></el-option>
                                                                                </el-select>
                                                                            </el-col>
                                                                            <el-col
                                                                                :xs="24"
                                                                                :sm="12"
                                                                                :md="10"
                                                                                :lg="8"
                                                                                :xl="6"
                                                                            >
                                                                                <el-date-picker
                                                                                    v-model="anoAtual"
                                                                                    type="year"
                                                                                    align="right"
                                                                                    size="small"
                                                                                    class="w-100 d-block">
                                                                                </el-date-picker>
                                                                            </el-col>
                                                                        </el-row>
                                                                    </div>
                                                                </b-form-group>
                                                                <message-validation :showError="showValidation == true &&  isNullOrEmpty(model.month)"></message-validation>
                                                                
                                                            </div>
                                                            <div class="col-lg-6 col-md-6">
                                                                <b-form-group id="modeloFluxo" label="Modelo de Fluxo:" label-for="modeloFluxoSelect" class="position-relative">
                                                                    <custom-select-single v-model="model.ModeloFluxo" :opt="listas.modeloFluxo" />
                                                                    <!-- <select2 required :options="listas.modeloFluxo" name="modeloFluxoSelect" v-model="model.ModeloFluxo"></select2> -->
                                                                </b-form-group>
                                                                <message-validation :showError="showValidation == true && model.ModeloFluxo == ''"></message-validation>

                                                                
                                                            </div>
                                                            <div class="col-lg-6 col-md-6">
                                                                <b-form-group id="statusFluxo" label="Status:" label-for="statusFluxoSelect">
                                                                    <el-select class="w-100" size="small" v-model="model.Status" name="statusFluxoSelect" placeholder="selecione">
                                                                        <el-option
                                                                        v-for="item in listas.status"
                                                                        :key="item.value"
                                                                        :label="item.label"
                                                                        :value="item.id">
                                                                        </el-option>
                                                                    </el-select>
                                                                </b-form-group>
                                                            </div>
                                                            <div class="col-lg-6 col-md-6">
                                                                <b-form-group id="empresas" :label="`Empresas${model.clusterEmpresaBool ? ' (Cluster)' : ''}:`" label-for="empresasASelect">
                                                                    <div class="toogle-multiselect-cluster">
                                                                        <small :class="model.analiseHorizontal ? 'label-toogle-cluster' : ''">{{ model.clusterEmpresaBool ? 'Alterar para empresas' : 'Alterar para cluster' }}&nbsp;&nbsp;</small>
                                                                        <el-switch 
                                                                        v-b-popover.hover.top="'Alternar combo clusters/empresas.'"
                                                                        v-model="model.clusterEmpresaBool"></el-switch>
                                                                    </div>
                                                                    <div class="check-inativas" :Style="model.clusterEmpresaBool == true ? 'left: 160px;' : ''">
                                                                        <el-checkbox v-model="excluirInativas">Excluir Inativas</el-checkbox>
                                                                    </div>
                                                                    <div v-show="model.clusterEmpresaBool == false">
                                                                        <custom-select-multiple 
                                                                          v-if="isRerender" 
                                                                          v-model="model.Empresas"
                                                                          group
                                                                           @options-loaded="updateClusterOptions"
                                                                          :url="`${$urls.EMPRESAS}?marcas=${model.marcas}&excluirInativos=${excluirInativas}`"
                                                                        />
                                                                    </div>
                                                                    <div v-show="model.clusterEmpresaBool == true">
                                                                        <custom-select-multiple v-if="isRerender" v-model="model.clusterEmpresa" :url="`${$urls.DRE_LISTA_CLUSTER}?empresasIds=${model.Empresas.join(',')}&excluirInativos=${excluirInativas}`" />
                                                                    </div>
                                                                </b-form-group>
                                                            </div>
                                                        </b-form-row>
                                                    </div>
                                                </b-form-row>
                                                <b-form-row>
                                                    <div class="col-md-12 col-lg-12">
                                                        <b-card bg-variant="light">
                                                            <h6><small>Parâmetros</small></h6>
                                                                <b-form-row>
                                                                    <div class="col-md-6">
                                                                        <b-form-checkbox :disabled="isTrazerSaldosDisabled"  v-model="model.TrazerSaldos"><small>Adicionar saldos iniciais e finais</small></b-form-checkbox>
                                                                        <!-- <b-form-checkbox v-model="model.ExibirParcelasNaoAprovadas"><small>Exibir parcelas de títulos pendentes de aprovação?</small></b-form-checkbox> -->
                                                                        <!-- <b-form-checkbox v-model="model.ValoresNosDiasOriginais"><small>Visualizar os valores de final de semana em seus dias originais ?</small></b-form-checkbox>
                                                                        <b-form-checkbox v-model="model.AdicionarUmDiaNoVencimentoDeBoletosAReceber"><small>Adicionar um dia no vencimento de boletos a receber (D + 1) ?</small></b-form-checkbox>
                                                                        <b-form-checkbox v-model="model.OcultarTitulosVencidos"><small>Ocultar receitas e despesas vencidas ?</small></b-form-checkbox> -->
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <!-- <b-form-checkbox v-model="model.OcultarTransferencias"><small>Ocultar as transferências entre contas ?</small></b-form-checkbox>
                                                                        <b-form-checkbox v-model="model.OcultarDinheiroDeCaixasAbertos"><small>Ocultar os valores em dinheiro caso o caixa do dia esteja aberto ?</small></b-form-checkbox> -->
                                                                    </div>
                                                                </b-form-row>
                                                        </b-card>
                                                    </div>
                                                </b-form-row>
                                            </div>
                                        </div>
                                    </b-form-row>
                                </b-form>

                                <div slot="footer">
                                    <div class="float-left btn-pesquisar" v-if="temAcesso('FluxoDeCaixa','Obter')">
                                        <el-button size="small" @click.prevent="pesquisarFluxo" type="primary" icon="el-icon-search" :disabled="pesquisarDisabled">Pesquisar</el-button> 
                                        <el-button size="small" @click.prevent="limparFluxoDeCaixa" icon="el-icon-brush">Limpar</el-button> 
                                    </div>
                                    <div class="float-left btn-pesquisar" v-else>
                                        <el-button size="small" type="primary" icon="el-icon-search" disabled v-b-tooltip.hover title="Sem permissões" class="no-drop">Pesquisar</el-button> 
                                    </div>
                                    
                                    <el-button class="float-right" v-if="temAcesso('FluxoDeCaixa','Exportar')" size="small" type="success" v-b-modal.modal-tipo-exportar icon="el-icon-download">Exportar</el-button>
                                    
                                    <div class="float-right btn-exportar" v-else>
                                        <el-button size="small" type="success" icon="el-icon-download" disabled v-b-tooltip.hover title="Sem permissões" class="no-drop">Exportar</el-button>
                                    </div>
                                </div>
                            </b-card>
                        </container-card>
                        <div :class="showList ? 'd-block' : 'd-none'">
                            <container-card fixed id="valoresFluxoDeCaixa" icon="fa-th-list" title="Valores pesquisados.">
                              <SaldosFluxoDeCaixa v-if="model.TrazerSaldos" title="Saldo Inicial" :amount="saldos.inicial.valor" :contas="saldos.inicial.contas" :showDetails="true"/>
                              <b-card>
                                    <treeview-fluxocaixa :dataJson="treeViewData" :mensagemErro="mensagemErro"></treeview-fluxocaixa>
                                </b-card>
                              <SaldosFluxoDeCaixa v-if="model.TrazerSaldos" title="Saldo Final" :contas="saldos.final.contas" :amount="saldos.final.valor" />
                              <div class="alert alert-info" v-if="model.TrazerSaldos">
                                <p class="mb-0 saldos-info">
                                   Poderão haver diferenças entre este saldo final e o saldo final visualizado pelo franqueado 
                                   na plataforma F360 Finanças, pois as fontes de dados não são todas as mesmas.
                                </p>
                              </div>
                            </container-card>
                        </div>
                    </div>
                </b-row>
            </el-tab-pane>
            <el-tab-pane>
                <span slot="label"><i class="far fa-chart-bar"></i> Extrato Bancário</span>
                <ExtratoBancario />
            </el-tab-pane>
            <el-tab-pane>
                <span slot="label"><i class="far fa-chart-bar"></i> Contas Bancárias</span>
                <ContasBancarias />
            </el-tab-pane>
        </el-tabs>
    </b-container>
</template>
<script>
import ContainerCard from '@/components/shared/ContainerCard'
import TreeViewFluxoDeCaixa from '@/components/TreeViewFluxoDeCaixa'
import Select2 from '@/components/shared/Select2'
import Select2Multiple from '@/components/shared/Select2Multiple'
import MessageValidation from '@/components/shared/MessageValidation'
import ModalExportar from '@/views/FluxoDeCaixa/ModalExportar'
import SelectMarcas from '@/components/shared/SelectMarcas'
import SaldosFluxoDeCaixa from '@/views/FluxoDeCaixa/SaldosFluxoDeCaixa'
import ExtratoBancario from '@/views/FluxoDeCaixa/ExtratoBancario/ExtratoBancario'
import MultiselectGroup from '@/components/shared/MultiselectGroup.vue'
import ContasBancarias from './ContasBancarias/ContasBancarias.vue'

const model = () => { 
    return {
        month: [],
        analiseHorizontal: false,
        showFilters: true,

        ModeloFluxo: null,
        Periodo: 'Diario',
        Inicio: '',
        Fim: '',
        Contas: [],
        Empresas: [],
        Status: '0',
        clusterEmpresaBool: false,
        clusterEmpresa: [],

        ExibirParcelasNaoAprovadas: false,
        ValoresNosDiasOriginais: false,
        AdicionarUmDiaNoVencimentoDeBoletosAReceber: false,
        OcultarTransferencias: false,
        OcultarDinheiroDeCaixasAbertos: false,
        OcultarTitulosVencidos: false,
        ExibirPrevisoes: false,
        TrazerSaldos: false,

        tipoCalendario: false,

        marcas: []

    }
}
const listas = () => {
    return {
        regimeOptions: [
            { text: 'Regime de Compotência', value: 1 },
            { text: 'Regime de Caixa', value: 2 }
        ],
        status: [
            { label: 'Ambos', id: '0' },
            { label: 'Abertos', id: '1' },
            { label: 'Liquidados', id: '2' }
        ],
        modeloFluxo: [],
        contas: [],
        empresas: [],
        cluster: []
    }
}


export default {
    name: 'fluxo-caixa',
    components: {
       ContainerCard,
       MessageValidation,
       ModalExportar,
       'select2': Select2,
       'select2-multiple': Select2Multiple,
       'treeview-fluxocaixa': TreeViewFluxoDeCaixa,
       MultiselectGroup,
       SelectMarcas,
       SaldosFluxoDeCaixa,
       ExtratoBancario,
       ContasBancarias
    },
    data(){
        const self = this


        return {
            showList: false,
            anoAtual: '',
            gerarRelatorioVisivel: false,
            configFiltro: [],
            showValidation: false,
            model: model(),
            listas: listas(),
            treeViewData: {},
            mensagemErro: {},
            pesquisarDisabled: false,
            isRerender: true,
            excluirInativas: false,
            pickerOptions: {
                shortcuts: [{
                    text: 'Hoje',
                    onClick(picker) {
                        picker.$emit('pick', [self.moment().toDate(), self.moment().toDate()])
                    }
                },
                {
                    text: 'Ontem',
                    onClick(picker) {
                        picker.$emit('pick', [self.moment().subtract(1, 'days').toDate(), self.moment().subtract(1, 'days').toDate()])
                    }
                },
                {
                    text: '2 meses',
                    onClick(picker) {
                        picker.$emit('pick', [self.moment().toDate(), self.moment().add(2, 'months').toDate()])
                    }
                },
                {
                    text: '3 meses',
                    onClick(picker) {
                        picker.$emit('pick', [self.moment().toDate(), self.moment().add(3, 'months').toDate()])
                    }
                },
                {
                    text: 'Último ano',
                    onClick(picker) {
                        picker.$emit('pick', [self.moment().toDate(), self.moment().endOf('year').toDate()])
                    }
                }]
            },
            exportarDisabled:  false,
            saldos: {
              inicial: {valor: 0, contas: []},
              final: {valor: 0, contas: []},
              
            }
        }
    },
    methods: {
        exportarFluxoCaixa() {
            const self = this
            if (!self.isValidFluxoDeCaixa()) return

            this.exportarDisabled = true

            let str = ""; //serializeParams
            let obj = self.paramsPesquisaFluxo()

            for (var key in obj) {
                if (str != "") {
                    str += "&";
                }
                var item = typeof obj[key] == "object" ? obj[key].toJSON() : obj[key]
                str += key + "=" + encodeURIComponent(item);
            }

            this.trackingF360(this, 'Fluxo de Caixa', 'Exportar');
            this.gerarRelatorio(str);

        },
        gerarRelatorio(str) {
            this.requestGerarRelatorio(str);
            this.gerarRelatorioVisivel = false;
        },
        async requestGerarRelatorio(str){
            let request = await this.axios.get(`${this.$urls.FLUXO_CAIXA_EXPORTAR_EM_MASSA}?${str}`);

            if(request.status !== 200) {
                this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
                return;
            }

            this.$notify({
                type: "success",
                title: 'Gerando Relatório',
                dangerouslyUseHTMLString: true,
                message: `Sua solicitação de relatório foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
            });
            this.exportarDisabled = false;
        },
        async requestGerarRelatorioTabela(url){
            this.exportarDisabled = true;
            let request = await this.axios.post(url, this.paramsPesquisaFluxo());

            if(request.status !== 200) {
                this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
                return;
            }

            this.$notify({
                type: "success",
                title: 'Gerando Relatório',
                dangerouslyUseHTMLString: true,
                message: `Sua solicitação de relatório foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
            });
            this.exportarDisabled = false;
        },
        isValidFluxoDeCaixa(){
            const self = this

            if(self.model.modeloFluxo == '' || self.isNullOrEmpty(self.model.month)){
                self.showValidation = true
                return false
            }
            return true
        },
        paramsPesquisaFluxo(){
            const self = this
            return {
                modeloDoFluxoId: self.model.ModeloFluxo,
                empresas: self.model.Empresas.length >= 1 ? self.model.Empresas.join(',') : '',
                clustersEmpresasIds: self.model.clusterEmpresa.length >= 1 ? self.model.clusterEmpresa.join(',') : '',
                inicio: self.model.Inicio,
                fim: self.model.Fim,
                status: self.model.Status,
                exibirParcelasNaoAprovadas: self.model.ExibirParcelasNaoAprovadas,
                valoresNosDiasOriginais: self.model.ValoresNosDiasOriginais,
                adicionarUmDiaNoVencimentoDeBoletosAReceber: self.model.AdicionarUmDiaNoVencimentoDeBoletosAReceber,
                ocultarTitulosVencidos: self.model.OcultarTitulosVencidos,
                tipoDePeriodo: self.model.Periodo,
                marcas: self.model.marcas.join(','),
                TrazerSaldos: self.model.TrazerSaldos,
                excluirInativas: self.excluirInativas
            }
        },
        pesquisarFluxo(){
            const self = this

            if (!self.isValidFluxoDeCaixa()) return

            self.pesquisarDisabled = true
            self.showList = true
            this.$root.$emit('loading',true)
            this.trackingF360(this, 'Fluxo de Caixa','Pesquisar');

            self.fluxoDeCaixaFiltros = self.paramsPesquisaFluxo()

            self.axios.get(this.$urls.FLUXO_CAIXA_ANALITICO, {
                params: self.paramsPesquisaFluxo()
            }).then((res) => {
                self.treeViewData = res.data
                self.setSaldos(res.data);
                self.$root.$emit('loading',false)

                if(res.data.length <= 0){
                    self.mensagemErro = { erro: false, msg: "Nada encontrado !" }
                }

                self.showValidation = false
                self.pesquisarDisabled = false

            }).catch(function () {
                self.treeViewData = {}
                self.$root.$emit('loading',false)

                self.pesquisarDisabled = false
                self.showValidation = false
                self.mensagemErro = { erro: true, msg: "Ocorreu algum problema com a requisição !" }
            })
        },
        setSaldos(values){
          if(!this.model.TrazerSaldos) return;

          const namesSaldos = { inicial: 'Saldo inicial', final: 'Saldo final' };
          const { saldos } = values;
          if(!saldos) return;

          const inicial = saldos.find(saldo => saldo.nome === namesSaldos.inicial);
          const final = saldos.find(saldo => saldo.nome === namesSaldos.final);

          this.saldos.final.valor = final ? final.valor || 0 : 0;
          this.saldos.final.contas = final ? final.contas || [] : [];
          this.saldos.inicial.valor = inicial ? inicial.valor || 0 : 0;
          this.saldos.inicial.contas = inicial ? inicial.contas || [] : [];

        },
        limparFluxoDeCaixa(){
            this.showValidation = false
            this.$data.model = model()
            this.callListas()

            this.model.month = ''
        },
        callListas(){
            // call ModeloFluxo
            var defaultModeloFluxo = (dt) => {
                if(!dt){ return false }
                    this.listas.modeloFluxo = dt

                    // Define modelo default 
                    dt.forEach((item) => {
                        if(item.default){
                            setTimeout(() => {
                                this.model.ModeloFluxo = item.id
                            },100)
                            return false
                        }   
                        this.model.ModeloFluxo = ''
                    })
            }
            if(this.isNullOrEmpty(this.listas.modelosDRE)){
                this.axios.get(this.$urls.FLUXO_CAIXA_ANALITICO_MODELOS).then((dt) => {
                    defaultModeloFluxo(dt.data)
                })
            }else{
                defaultModeloFluxo(this.listas.modelosDRE)
            }
        },
        changePeriodo() {
            this.model.month = []
        },
        existeMaisDeDoisGrupos(val) {
            const maxGrupos = 1;

            if (val && val.length > 0) {
                const lastPosition = val[val.length - 1];
                const grupos = new Set();

                this.listas.Empresas.forEach(empresas => {
                    const hasEmpresa = empresas.children.find(c => c.id === lastPosition);
                    if (hasEmpresa) grupos.add(empresas.id);
                });

                return grupos.size > maxGrupos;
            }

            return false;
        },
        updateClusterOptions(options) {
            this.listas.Empresas = options
        },
    },
    computed: {
        isTrazerSaldosDisabled(){
            return !this.model.Empresas.length;
        },
		fluxoDeCaixaFiltros: {
            get() {
                return this.$store.state.fluxoDeCaixaFiltros;
            },
            set(value) {
                this.$store.commit('updateFluxoDeCaixaFiltros', value);
            }
        },
        anoAtualFormatado() {
            this.model.month = ''
            return this.moment(this.anoAtual).year()
        }
    },
    watch: {
        'model.month': function(val){
            if(!this.isNullOrEmpty(val)){
                this.model.Inicio = val[0]
                this.model.Fim = val[1]
            }else{
                this.model.Inicio = ''
                this.model.Fim = ''
            }
        },
        'model.clusterEmpresaBool': {
			handler() {
                //this.model.Empresas = []
                this.model.clusterEmpresa = []
			}
        },
        model: {
            handler: function(){
                this.showList = false
            },
            deep: true
        },
        'model.marcas'() { // sempre que marcas for alterado, redesenha o select de empresas
            this.isRerender = false;
            this.$nextTick(()=>{ 
                this.listas.empresas = []
                this.isRerender = true;
            });
        },
        'model.Empresas': function(val){
            const checkGrupos =  this.existeMaisDeDoisGrupos(val);
            const setFalse = checkGrupos || !val.length;
            if(setFalse) this.model.TrazerSaldos = false;
        },
        'excluirInativas'() { // sempre que excluirInativas for alterado, redesenha o select de empresas
            this.isRerender = false;
            this.$nextTick(()=>{ 
                this.listas.empresas = []
                this.isRerender = true;
            });
        }
    },
    created(){
        const self = this
        self.callListas()
        self.anoAtual = new Date()

        self.$root.$on('empresasSelectOptions',function(data){
            self.listas.Empresas = data
        })
        self.$root.$on('empresasClusterSelectOptions',function(data){
            self.listas.Empresas = data
        })

    }
}
</script>
<style lang="scss">
    .saldos-info{
      font-size: 13px;
    }
    .fluxo-caixa-container {
        .toogle-multiselect-cluster {
            position: absolute;
            top: -4px;
            right: 6px;
        }
    }
    .check-inativas {
        position: absolute;
        top: 0;
        left: 95px;
    }
</style>
